import * as React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import { FormSelectChoice, InputSelectComponentProps } from '../../../lib/types/types';
import { InputSelectComponent } from '../../FormInputs/InputSelect/InputSelectComponent';

const CountryComponent = ({ value, isErrored, options, onChange, onKeyDown }: InputSelectComponentProps) => {
    return (
        <div className="sid-field sid-country">
            <div className="sid-l-space-top-md" />
            <label htmlFor="sid-country">
                <div className="sid-field__label sid-country__label sid-l-space-btm-sm">
                    <FormattedHTMLMessage
                        id="country"
                        defaultMessage="Country where you go to school"
                    />
                </div>
            </label>
            <InputSelectComponent
                fieldId="country"
                inputId="sid-country"
                isErrored={isErrored}
                options={ options }
                onChange={(country: FormSelectChoice) => onChange(country)}
                onKeyDown={onKeyDown}
                value={value}
            />
            {
                isErrored ? (
                    <div className="sid-field-error">
                        <FormattedHTMLMessage
                            id="errorId.invalidCountry"
                            defaultMessage="Invalid country"
                        />
                    </div>
                ) : null
            }
        </div>
    );
};

export { CountryComponent };
